import { ComponentDesign } from '@paragon/contract-library';

import { useAppSelector } from '../../../../hooks';

export function useLoadCaseLoader(searchTerm: string) {
  const loadSets = useAppSelector((state) => state.loadSets);
  return function loadCaseLoader(componentDesign: ComponentDesign) {
    if (!componentDesign.loadSetGuid) return [];

    const loadSet = loadSets[componentDesign.loadSetGuid];
    const result = loadSet ? loadSet.loadCases.toSorted((a, b) => a.index - b.index) : [];

    return result.filter((set) => set.name.toLowerCase().includes(searchTerm));
  };
}
